import ControlViewModel from '@/ViewModels/ControlViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import HiddenViewModel from '@/ViewModels/Controls/HiddenViewModel';
import MultiSelectAutoComplete from '@/ViewModels/Controls/MultiSelectAutoCompleteViewModel';
import ComponentManager from '@/Management/ComponentManager';

/**
 * Das ViewModel für die AssociationSingleAutocompleteBox
 */
export default class AssociationSingleAutocompleteBoxViewModel extends ControlViewModel {

    /**
     * Die wählbaren Optionen
     */
    public multiSelectAutoComplete: MultiSelectAutoComplete;

    /**
     * Das ViewModel für das Hidden
     */
    public hidden: HiddenViewModel;

    /**
     * Das ViewModel für den Link zum Erzeugen eines neuen Objekts
     */
    public linkCreate: LinkViewModel;

    /**
     * Das ViewModel für den Link zum Selektieren eines bestehenden Objekts
     */
    public linkSelect: LinkViewModel;

    /**
     * Das ViewModel für den Link zum Editieren des assoziierten Objekts
     */
    public linkEdit: LinkViewModel;

    /**
     * Das ViewModel für den Link zum Lösen der Association
     */
    public linkDisconnect: LinkViewModel;

    /**
     * Das ViewModel für den Link zum Löschen des assoziierten Objekts
     */
    public linkDelete: LinkViewModel;

    /**
     * Die Funktion zum Lösen der Association
     */
    public disconnectItem: Function;

    constructor(params: any) {
        super(params);
        this.multiSelectAutoComplete = this.paramOrDefault(params.multiSelectAutoComplete, null);
        this.hidden = this.paramOrDefault(params.hidden, null);
        this.linkCreate = this.paramOrDefault(params.linkCreate, null);
        this.linkSelect = this.paramOrDefault(params.linkSelect, null);
        this.linkEdit = this.paramOrDefault(params.linkEdit, null);
        this.linkDisconnect = this.paramOrDefault(params.linkDisconnect, null);
        this.linkDelete = this.paramOrDefault(params.linkDelete, null);
        this.disconnectItem = this.handlerOrDefault(params.disconnectItem);
    }
}

ComponentManager.setViewModel('AssociationSingleAutocompleteBoxViewModel', AssociationSingleAutocompleteBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');